import React from "react";
import { motion } from "framer-motion";

const CategorySkeleton = () => {
  const skeletonCategories = Array.from({ length: 8 }, (_, index) => index);

  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-xl xl:rounded-3xl p-3 xl:p-6 border border-white/10 sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto no-scrollbar">
      {/* Title Skeleton */}
      <div className="mb-3 xl:mb-6">
        <div className="h-6 bg-gray-600/50 rounded animate-pulse w-32"></div>
      </div>
      
      <div className="space-y-3">
        {skeletonCategories.map((index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="w-full group relative overflow-hidden rounded-xl xl:rounded-2xl bg-white/5 border border-white/10"
          >
            <div className="flex items-center justify-between p-2 xl:p-4">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 bg-gray-600/50 rounded animate-pulse"></div>
                <div className="h-4 bg-gray-600/50 rounded w-20 animate-pulse"></div>
              </div>
              <div className="w-8 h-5 bg-gray-600/50 rounded-full animate-pulse"></div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CategorySkeleton;
